import { useState } from 'react';
import { ExerciseDisplayUnits } from '@guryou/core';

const useExerciseDisplayUnits = () => {
  const [values, setValues] = useState(null);

  if (!values) {
    setValues([
      { value: ExerciseDisplayUnits.times, label: 'Times' },
      { value: ExerciseDisplayUnits.min, label: 'Minutes' },
      { value: ExerciseDisplayUnits.sec, label: 'Seconds' },
      { value: ExerciseDisplayUnits.meters, label: 'Meters' },
      { value: ExerciseDisplayUnits.km, label: 'Kilometers' },
      { value: ExerciseDisplayUnits.kg, label: 'Kilograms' },
      { value: ExerciseDisplayUnits.pounds, label: 'Pounds' },
      { value: ExerciseDisplayUnits.percent, label: 'Percent' },
      { value: ExerciseDisplayUnits.kcal, label: 'Kcal' },
      { value: ExerciseDisplayUnits.hours, label: 'Hours' },
    ]);
  }

  return values;
};

export default useExerciseDisplayUnits;
